export const harvestYearDetail = () => {
    let harvestYear = {}
    harvestYear = JSON.parse(localStorage.getItem("selectedHarvestYear"));

    return {
        id: harvestYear && harvestYear.id,
        name: harvestYear && harvestYear.name
    }
}


// WEBPACK FOOTER //
// ./src/config/harvestYearDetail.js